import { useMutation, useQuery } from '@tanstack/react-query';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { getFiledLawsuit, saveFiledLawsuit } from 'app/edozvola/cases/filed-lawsuit/service/filed-lawsuit.service';
import { FiledLawsuitModel } from 'app/edozvola/cases/filed-lawsuit/model/filed-lawsuit.model';
import success = toast.success;
import error = toast.error;
import {messages} from "app/config/constants";

export const fetchFiledLawsuitQuery = (caseUuid: string) => {
  return useQuery({
    queryKey: ['filedLawsuit', caseUuid],
    queryFn: () => getFiledLawsuit(caseUuid),
    enabled: !!caseUuid,
  });
};

export const saveFiledLawsuitQuery = (caseUuid: string, resetFunction) => {
  return useMutation({
    mutationFn: (filedLawsuit: FiledLawsuitModel) => {
      return saveFiledLawsuit(caseUuid, filedLawsuit);
    },
    onSuccess: (data, variables) => {
      showToast(success, messages.DATA_SAVED);
      resetFunction({ values: variables });
    },
    onError: (err: any) => {
      showToast(error, err);
    },
  });
};
